const state = {
    apitoken:''
  };
  
  const mutations = {
  
  };
  
  const actions = {
  
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  
  


// WEBPACK FOOTER //
// ./src/store/checkICPInfo.js